<div class="centertext">
  <span *ngIf="data.confirm" name="toastspacer">&nbsp;&nbsp;&nbsp;</span>
  <span *ngIf="data.message"> {{ data.message }}</span>
  <span *ngIf="data.messageKey"> {{ data.messageKey | translate }}</span>
  <span *ngIf="data.confirm" name="toastspacer">&nbsp;&nbsp;&nbsp;</span>
  <button class="btn btn-primary" (click)="snackBarRef.dismiss()" *ngIf="data.confirm">
    <b>{{ 'NotificationLogs.CloseDialog' | translate }}</b>
  </button>
  <mat-icon *ngIf="!data.confirm" class="material-icons">done</mat-icon>
</div>
